export const TOGGLE_ADD_WHS_DOCUMENTS_MODAL = 'TOGGLE_ADD_WHS_DOCUMENTS_MODAL';

function openAddWhsDocumentsModal() {
  return {
    type: TOGGLE_ADD_WHS_DOCUMENTS_MODAL,
    isAddWhsDocumentsModalShown: true,
  };
}

function closeAddWhsDocumentsModal() {
  return {
    type: TOGGLE_ADD_WHS_DOCUMENTS_MODAL,
    isAddWhsDocumentsModalShown: false,
  };
}

export function showAddWhsDocumentsModal() {
  return (dispatch) => {
    dispatch(openAddWhsDocumentsModal());
  };
}

export function hideAddWhsDocumentsModal() {
  return (dispatch) => {
    dispatch(closeAddWhsDocumentsModal());
  };
}
